module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_25.587320b3.png";